module.exports = require('./helpers/bundle-url').getBundleURL('lPpKD') + "mobile.49e04b51.mp4" + "?" + Date.now();